/* Lightweight motion for the membership page. No libraries.
   Demo values are filled from membership-data.js when that file is loaded.
   Shopify pages leave AS_MEMBERSHIP unset and keep the Liquid output. */
(function () {
  try { applyMembershipData(); } catch (error) { /* keep the page usable if demo data is missing */ }

  var root = document.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  root.classList.add("as-js");
  if (reduce) root.classList.add("as-reduce");

  var reveal = document.querySelectorAll("[data-reveal]");
  if (!reduce && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -8% 0px" }
    );
    reveal.forEach(function (node) { io.observe(node); });
  } else {
    reveal.forEach(function (node) { node.classList.add("is-in"); });
  }

  document.querySelectorAll("[data-dash]").forEach(function (dash) {
    var tabs = dash.querySelectorAll("[data-tab]");
    var panels = dash.querySelectorAll("[data-panel]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var name = tab.getAttribute("data-tab");
        tabs.forEach(function (item) {
          var on = item === tab;
          item.setAttribute("aria-selected", on ? "true" : "false");
          item.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute("data-panel") !== name;
        });
      });
    });
  });

  if (reduce) return;
  var hero = document.querySelector("[data-hero]");
  var bike = hero && hero.querySelector("[data-bike]");
  var shadow = hero && hero.querySelector("[data-shadow]");
  var glow = hero && hero.querySelector("[data-glow]");
  if (!hero || !bike) return;

  var desktop = window.matchMedia("(min-width: 1000px) and (pointer: fine)");
  var aimX = 0;
  var aimY = 0;
  var curX = 0;
  var curY = 0;
  var scrollY = 0;

  function onMove(event) {
    var box = hero.getBoundingClientRect();
    aimX = (event.clientX - box.left) / box.width - 0.5;
    aimY = (event.clientY - box.top) / box.height - 0.5;
  }

  function onLeave() {
    aimX = 0;
    aimY = 0;
  }

  function bindDesktop() {
    if (!desktop.matches) return;
    hero.addEventListener("mousemove", onMove);
    hero.addEventListener("mouseleave", onLeave);
  }

  bindDesktop();
  if (desktop.addEventListener) {
    desktop.addEventListener("change", function () {
      if (desktop.matches) {
        bindDesktop();
      } else {
        hero.removeEventListener("mousemove", onMove);
        hero.removeEventListener("mouseleave", onLeave);
        bike.style.transform = "";
        if (shadow) shadow.style.transform = "";
        if (glow) glow.style.transform = "";
      }
    });
  }

  window.addEventListener("scroll", function () {
    var y = window.scrollY || 0;
    scrollY = y < window.innerHeight ? Math.min(y * 0.05, 28) : scrollY;
  }, { passive: true });

  function frame(now) {
    if (desktop.matches) {
      curX += (aimX - curX) * 0.1;
      curY += (aimY - curY) * 0.1;
      var sway = Math.sin(now / 1400) * 4;
      var bob = Math.sin(now / 900) * 10;
      var rotY = 8 + sway + curX * 32;
      var rotX = 5 + Math.cos(now / 1700) * 2.5 + curY * -22;
      var shiftX = curX * 28;
      var shiftY = bob + curY * 16 + scrollY;
      bike.style.transform = "rotateX(" + rotX.toFixed(2) + "deg) rotateY(" + rotY.toFixed(2) + "deg) translate3d(" + shiftX.toFixed(1) + "px," + shiftY.toFixed(1) + "px, 70px)";
      if (shadow) {
        shadow.style.transform = "translate3d(" + (shiftX * -0.65).toFixed(1) + "px," + (bob * 0.35).toFixed(1) + "px, 0) scaleX(" + (1.05 - curX * 0.18).toFixed(3) + ")";
      }
      if (glow) {
        glow.style.transform = "translate3d(" + (shiftX * 0.45).toFixed(1) + "px," + (shiftY * 0.25).toFixed(1) + "px, 0)";
      }
    }
    window.requestAnimationFrame(frame);
  }

  window.requestAnimationFrame(frame);
})();

function applyMembershipData() {
  var data = window.AS_MEMBERSHIP;
  var page = document.querySelector(".as-membership");
  if (!data || !data.membership || !page) return;

  var state = data.account && data.account.state;
  if (state !== "logged_out" && state !== "logged_in" && state !== "active_member" && state !== "non_member") {
    state = "logged_out";
  }
  page.setAttribute("data-account-state", state);
  page.setAttribute("data-membership-price-cents", String(data.membership.priceCents));

  function fill(name, value) {
    if (value == null || value === "") return;
    page.querySelectorAll("[data-as='" + name + "']").forEach(function (el) {
      el.textContent = String(value);
    });
  }

  function bind(name, action) {
    if (!action) return;
    page.querySelectorAll("[data-action='" + name + "']").forEach(function (el) {
      if (action.href) el.setAttribute("href", action.href);
      if (action.label) el.textContent = action.label;
    });
  }

  fill("membership.name", data.membership.name);
  fill("membership.priceLabel", data.membership.priceLabel);
  fill("demo.memberStatus", data.demo && data.demo.memberStatus);
  fill("demo.orderCount", data.demo && data.demo.orderCount);
  fill("customer.profile", data.customer && data.customer.profile);
  fill("customer.passwordNote", data.customer && data.customer.passwordNote);

  var order = data.orders && data.orders[0];
  if (order) {
    fill("order.number", "#" + order.number);
    fill("order.heading", "Order #" + order.number);
    fill("order.product", order.productName);
    fill("order.status", order.orderStatus);
    fill("order.fulfillment", order.fulfillmentStatus);
    fill("order.delivery", order.deliveryStatus);
    (order.steps || []).forEach(function (step, index) {
      fill("order.step." + index, step);
    });
  }

  ["active", "future"].forEach(function (group) {
    var list = data.benefits && data.benefits[group];
    if (!list) return;
    list.forEach(function (item, index) {
      fill("benefits." + group + "." + index + ".title", item.title);
      fill("benefits." + group + "." + index + ".text", item.text);
    });
  });

  bind("join", data.actions && data.actions.join);
  bind("account", data.actions && data.actions.account);
  if (state === "logged_in" || state === "active_member") {
    bind("sign-in", data.actions && data.actions.account);
    bind("sign-in-short", data.actions && data.actions.account);
  } else {
    bind("sign-in", data.actions && data.actions.signIn);
    bind("sign-in-short", data.actions && data.actions.signInShort);
  }
}
